module.exports = __webpack_public_path__ + "static/media/46.9bc1733.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/46.wav
// module id = SoLO
// module chunks = 0